import React from "react";
import _ from "lodash";
import cx from "classnames";
import PropTypes from "prop-types";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";

const {
  PRIMARIES,
  RM_FORMULAS,
  LOAD_FORMULAS,
  LIST_FORMULAS,
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../../../constants");

function View(props, { locals }) {
  _.defaults(locals.query, {
    type: "total",
    display: "estimated",
    units: "metric",
  });

  const { snapshot, query, momentTZ } = locals;
  const { units, display } = query;
  const hover = display === "estimated" ? "actual" : "estimated";
  const formula = _.get(snapshot, "data.formula", LIST_FORMULAS[0]);
  let exercisesRecordsLoad = _.get(snapshot, "data.exercisesRecordsLoad", {});
  exercisesRecordsLoad =
    query.type === "total"
      ? exercisesRecordsLoad
      : _.pick(exercisesRecordsLoad, [query.type]);

  return (
    <div className="Main">
      <h1 className="alt">Rep Max Estimator</h1>
      <p>
        An estimated rep maximum for any exercise or rep range. Compare your
        estimates with your actual numbers to gauge ability and performance.
      </p>

      <form id="metrics-form" action="#_" method="GET" data-noreset>
        <div className="Table-Head">
          <div className="right-side">
            <div className="group Formula-Selector">
              Formula
              <select
                onChange={submitForm}
                name="formula"
                className="select-input"
                defaultValue={formula}
              >
                <option disabled>Select a formula</option>
                {_.map(LIST_FORMULAS, (type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            <div className="group">
              <ToggleLinksInput
                name="display"
                options={[
                  { text: "Estimated", value: "estimated" },
                  { text: "Actual", value: "actual" },
                ]}
              />
            </div>
            <div className="group">
              <ToggleLinksInput
                name="units"
                options={[
                  { text: "kg", value: "metric" },
                  { text: "lbs", value: "imperial" },
                ]}
              />
            </div>
          </div>

          <div className="left-side">
            <div className="group">
              <ToggleLinksInput
                className="tabs"
                name="type"
                options={[
                  { text: "Total", value: "total" },
                  { text: "Squat", value: "squat" },
                  { text: "Bench", value: "bench" },
                  { text: "Deadlift", value: "deadlift" },
                ]}
              />
            </div>
          </div>
        </div>

        <div className="Table-Wrapper">
          <table className="Table">
            <thead>
              <tr>
                <th>
                  <span className="left">Exercise</span>
                  <span className="right">Reps:</span>
                </th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
                <th>8</th>
                <th>9</th>
                <th>10</th>
                <th>11</th>
                <th>12</th>
              </tr>
            </thead>
            <tbody>
              {_.flatMap(PRIMARIES, (primary) => {
                const secondaries = exercisesRecordsLoad[primary];
                return _(secondaries)
                  .map((reps, secondary) => {
                    return { reps, secondary };
                  })
                  .sortBy("secondary")
                  .map(({ reps, secondary }) => {
                    const secondaryLabel = secondary ? `(${secondary})` : "";
                    let bestRep = 0;
                    let best1RepMax = 0;

                    _.forEach(reps, ({ load }, rep) => {
                      const repMax = loadTo1RepMax(load, rep);
                      if (repMax > best1RepMax) {
                        best1RepMax = repMax;
                        bestRep = Number(rep);
                      }
                    });

                    return (
                      <tr key={primary + secondary}>
                        <td>
                          {_.capitalize(primary)} {secondaryLabel}
                        </td>
                        {_.map(_.range(1, 13), (i) => {
                          const isBest = bestRep === i;
                          const date =
                            _.has(reps[i], "date") && momentTZ(reps[i].date);
                          const loads = {
                            actual: _.get(reps[i], "load"),
                            estimated: repMaxToLoad(best1RepMax, i),
                          };
                          const displayText =
                            locals.fromMetric(loads[display], units) || "-";
                          const hoverText = `${_.capitalize(hover)}: ${
                            locals.fromMetric(loads[hover], units) || "-"
                          }`;
                          return (
                            <td key={i} className={cx({ best: isBest })}>
                              <span>
                                <span>{displayText}</span>
                                <div
                                  className="tooltip"
                                  dangerouslySetInnerHTML={{
                                    __html: hoverText,
                                  }}
                                />
                              </span>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                  .value();
              })}
              <tr className="no-hover">
                <td className="personal-best" colSpan="13">
                  <b>Personal best</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="Metrics-Foot">
          <a
            className="support text-button icon"
            href="/dashboard/support/videos?video=xEknnLP5Ns8"
          >
            <img src="/img/svg/icon_support-2.svg" alt="icon" />
            Need Help?
          </a>
        </div>
      </form>
    </div>
  );

  function loadTo1RepMax(load, reps) {
    if (Number(reps) === 1) return load;
    return RM_FORMULAS[formula](load, reps);
  }

  function repMaxToLoad(rm, reps) {
    return LOAD_FORMULAS[formula](rm, reps);
  }
}

function submitForm() {
  submit("#_", { body: document.getElementById("metrics-form") });
}

View.contextTypes = { locals: PropTypes.object };

export default View;
